export default function () {
    return {
        city: '',
        regionName: '',
        locations: null,
    };
}
